import React, { Fragment } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import Navbar from "../../components/Navbar/Navbar";
import PageTitle from "../../components/pagetitle/PageTitle";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";

import { removeFromWishList, addToCart } from "../../store/actions/action";

// 🧾 Types
export interface ProductItem {
  id: number | string;
  title: string;
  price?: number | string;
  stock?: string;
  brand?: string;
  size?: string;
  proImg?: string;
}

interface WishlistPageProps {
  wishs: ProductItem[];
  removeFromWishList: (id: number | string) => void;
  addToCart: (product: ProductItem, qty?: number) => void;
}

const WishlistPage: React.FC<WishlistPageProps> = ({
  wishs,
  removeFromWishList,
  addToCart,
}) => {
  return (
    <Fragment>
      <Navbar hclass="wpo-header-style-1" />
      <PageTitle pageTitle="Wishlist" pagesub="Wishlist" />

      <div className="cart-area section-padding">
        <div className="container">
          <div className="form">
            <div className="cart-wrapper">
              <div className="row">
                <div className="col-12">
                  {wishs && wishs.length > 0 ? (
                    <form>
                      <table className="table-responsive cart-wrap">
                        <thead>
                          <tr>
                            <th className="images images-b">Image</th>
                            <th className="product-2">Product Name</th>
                            <th className="ptice">Price</th>
                            <th className="pr">Stock Status</th>
                            <th className="remove remove-b">Action</th>
                          </tr>
                        </thead>

                        <tbody>
                          {wishs.map((wish, index) => (
                            <tr key={wish.id || index}>
                              <td className="images">
                                {wish.proImg && (
                                  <img src={wish.proImg} alt={wish.title} />
                                )}
                              </td>

                              <td className="product">
                                <ul>
                                  <li className="first-cart">{wish.title}</li>
                                  {wish.brand && <li>Brand: {wish.brand}</li>}
                                  {wish.size && <li>Size: {wish.size}</li>}
                                </ul>
                              </td>

                              <td className="ptice">
                                ${wish.price ?? "0.00"}
                              </td>
                              <td className="stock">
                                {wish.stock ?? "Available"}
                              </td>

                              <td className="action">
                                <ul>
                                  {/* 🛒 Add to Cart */}
                                  <li className="c-btn">
                                    <button
                                      type="button"
                                      className="c-btn"
                                      onClick={() => addToCart(wish, 1)}
                                      title="Add to Cart"
                                    >
                                      <i className="fi flaticon-shopping-cart"></i>
                                    </button>
                                  </li>

                                  {/* 🗑 Remove from Wishlist */}
                                  <li className="w-btn">
                                    <button
                                      type="button"
                                      onClick={() => removeFromWishList(wish.id)}
                                      title="Remove from Wishlist"
                                    >
                                      <i className="fi ti-trash"></i>
                                    </button>
                                  </li>
                                </ul>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </form>
                  ) : (
                    <div className="empty-cart text-center py-5">
                      <h3>Your wishlist is empty 💔</h3>
                      <p>Browse our products and add items you love.</p>
                      <Link to="/shop" className="theme-btn">
                        Go to Shop
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer footerClass="wpo-site-footer-s1" />
      <Scrollbar />
    </Fragment>
  );
};

const mapStateToProps = (state: any) => ({
  wishs: state.wishList.w_list,
});

export default connect(mapStateToProps, {
  removeFromWishList,
  addToCart,
})(WishlistPage);
